<template>
    <div class="bodyPage">
        <v-data-table
            :headers="tableHeaders"
            :items="users || []"
            class="elevation-4 table"
            :loading="loading"
            :loading-text="labels.textLoading"
            v-resize="onResize"
            :search="search"
            :items-per-page=50
            :footer-props="{
                'items-per-page-text': labels.itemsPerPage,
                showFirstLastpage:true,
                'items-per-page-options':[10, 50, 100, -1]
            }"
        >
            <template v-slot:top>
                <v-toolbar flat >
                    <v-toolbar-title>{{'Usuários' | translate('Usuarios')}}</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        :label="labels.buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-dialog
                        v-model="dialog"
                        scrollable
                        :max-width="editDialogWidth"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="btn1" 
                                v-bind="attrs"
                                v-on="on"
                                dark
                                small
                                @click="clearEdititem(); editItem({});"
                            >
                                <v-icon small>
                                    mdi-plus
                                </v-icon>
                                <span>{{ 'Novo' | translate('Usuarios') }}</span>
                            </v-btn>
                        </template>
                        <v-form ref="form">
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ 'Cadastro de Usuário' | translate('Usuarios')}} </span>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="registrationDialog">
                                    <v-container>
                                        <v-row class="rowPadding">
                                            <v-col cols="12">
                                                <v-text-field
                                                    autofocus
                                                    v-model="editedItem.NOME"
                                                    :label="labels.nome"
                                                    :rules="[rules.required]"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="rowPadding">
                                            <v-col cols="12">
                                                <v-text-field
                                                    v-model="editedItem.EMAIL"
                                                    :label="labels.email"
                                                    :rules="[rules.email]"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="rowPadding">
                                            <v-col cols="12">
                                                <v-autocomplete
                                                    dense
                                                    v-model="editedItem.FUNCAO_USUARIO_ID"
                                                    :items="userRoles"
                                                    item-text="DESCRICAO"
                                                    ref="autocompleteFunction"
                                                    item-value="ID"
                                                    clearable
                                                    height="30px"
                                                    v-if="editedItem.userType == 'P'"
                                                    :menu-props="{closeOnContentClick:true}"
                                                    :rules="[rules.operatorFunction]"
                                                    :error-messages="autocompleteFunctionErrorMessages"
                                                >
                                                    <template #label>
                                                        <span>{{labels.funcao}}</span> 
                                                        <span class="red--text"><strong>*</strong></span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row  style="height: 4em; margin-top:0; margin-left: .5em;">
                                            <v-col cols="12" style="padding-top:4px;">
                                                <v-radio-group
                                                    v-model="userType"
                                                    row
                                                >
                                                    <v-radio
                                                        key="operatorRadio"
                                                        :label="labels.operador"
                                                        value="P"
                                                    ></v-radio>
                                                    <v-radio
                                                        key="customerRadio"
                                                        :label="labels.cliente"
                                                        value="C"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>
                                        <v-row  class="rowPadding">
                                            <v-col cols="12">
                                                <v-autocomplete
                                                    dense
                                                    v-model="editedItem.CLIENTE_ID"
                                                    :items="clients"
                                                    item-text="NOME"
                                                    ref="autocompleteCustomer"
                                                    item-value="ID"
                                                    clearable
                                                    :loading="loadingClients"
                                                    :disabled="editedItem.userType == 'P'"
                                                    :rules="[rules.customer]"
                                                    :error-messages="autocompleteCustomerErrorMessages"
                                                >
                                                    <template #label>
                                                        <span>{{labels.cliente}}</span> 
                                                        <span class="red--text"><strong>*</strong></span>
                                                    </template>
                                                    <!-- <template v-slot:item="data">
                                                        <span>{{data.item.NOME}}</span>
                                                    </template> -->
                                                    <!-- <template v-slot:append-item>
                                                        <v-divider/>
                                                        <v-row>
                                                            <v-col>
                                                                <v-btn 
                                                                    plain 
                                                                    style="width: inherit;" 
                                                                    @click="addPerson(true)"
                                                                >
                                                                    <v-icon color="#1976d2">
                                                                        mdi-account-plus-outline
                                                                    </v-icon>
                                                                    <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Cliente' | translate('Usuarios')}}</span>
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </template> -->
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="11">
                                                <v-checkbox
                                                    v-model="editedItem.OCULTAR_ATEND_NAO_VINCULADO"
                                                    :label="labels.hidesUnlinkedCall"
                                                    true-value="S"
                                                    false-value="N"
                                                >
                                                </v-checkbox>
                                            </v-col>
                                            <v-col cols="1" style="align-self: center; text-align: left;">
                                                <v-tooltip
                                                    top
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            style="cursor:pointer;"
                                                            color="red"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            mdi-help
                                                        </v-icon>
                                                    </template>
                                                    Quando selecionado:<br/>- Oculta atendimentos (inclusive atendimentos com situação "Inicial") dos quais usuários de clientes não estejam vinculados, mesmo que sendo administradores.<br/>- Oculta atendimentos (inclusive atendimentos com situação "Inicial") dos quais usuários operadores não estejam vinculados, apenas quando não são administradores.
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                    <v-btn
                                        class="white--text btn1" 
                                        small
                                        color="black"
                                        @click="close"
                                    >
                                        {{'Cancel' | translate('Usuarios')}}
                                    </v-btn>
                                    <v-btn 
                                        class="white--text btn1" 
                                        small
                                        :loading="loading"
                                        color="black"
                                        @click="save('')"
                                        :disabled="validateForm()"
                                    >
                                        {{'Save' | translate('Usuarios')}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.imagem`]="{ item }">
                <v-avatar
                    class="avatar"
                    @click="floatingMenuCollapsed = !floatingMenuCollapsed"
                    size="40px"
                >
                    <img
                        alt="Avatar"
                        width="40"
                        height="40"
                        :src="getAvatarimage(item.IMAGEM_PERFIL)"
                    >
                </v-avatar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-row>
                    <v-col>
                        <v-btn 
                            icon 
                            @click="editItem(item)"
                        >
                            <v-icon
                                small
                                color="black"
                            >
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:[`item.ADM`]="{ item }">
                <v-row>
                    <v-col class="actionButtons">
                        <v-switch
                            v-model="item.ADM"
                            true-value="S"
                            false-value="N"
                            color="black"
                            inset
                            :disabled="user.ADM != 'S'"
                            @change="save(item)"
                        ></v-switch>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:[`item.ATIVO`]="{ item }">
                <v-row>
                    <v-col class="actionButtons">
                        <v-switch
                            v-model="item.ATIVO"
                            true-value="S"
                            false-value="N"
                            color="black"
                            inset
                            :disabled="user.ADM != 'S'"
                            @change="save(item)"
                        ></v-switch>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:[`item.excluirUsuario`]="{ item }">
                <v-row>
                    <v-col class="actionButtons">
                        <v-btn
                            icon
                            @click="deleteUserModal(item)"
                        >
                            <v-icon
                                small
                                color="black"
                            >
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </v-data-table>
        <v-dialog
                    v-model="deleteUserDialog"
                    scrollable
                    :max-width="editDialogWidth"
                >
                <v-card>
                    <v-card-title class="justify-center">
                    <v-icon
                                    small
                                    color="red"
                                    class="text-center"
                                >
                                    mdi-delete
                                </v-icon>
                    </v-card-title>
                    <v-card-text class="px-4 pt-4 pb-3 black--text" >
                    Deseja mesmo excluir este usuário?
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="white darken-1"
                        class="black"
                        text
                        @click="deleteUserDialog = false"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                        color="white darken-1"
                        text
                        class="black"
                        @click="deleteUser()"
                    >
                        Yes
                    </v-btn>
                    </v-card-actions>
                </v-card>
             </v-dialog>
    </div>
</template>

<script>
import translate from '../../../../src/plugins/translate'
import loadAllByCompanyId from '../../../../src/app/usuario/loadAllbyCompanyId'
import loadAllUserRoles from '../../../../src/app/usuario/loadAllUserRoles'
import addUserCompany from '../../../../src/app/empresa_usuario/addUserCompany'
import updateUserCompany from '../../../../src/app/empresa_usuario/updateUserCompany'
import deleteProduct from '../../../../src/app/empresa_usuario/deleteUserCompany'
import getClientsByCompanyIdAndName from '../../../../src/app/cliente/loadAll'
import deleteUser from '../../../../src/app/usuario/deleteUser'
import { createNamespacedHelpers } from 'vuex'

const user = createNamespacedHelpers('user')

export default {
    name: 'Usuarios',
    components: {},
    data() {
        return {
            userToDelete : null,
            deleteUserDialog : false,
            client: null,
            search: null,
            searchClient: null,
            editDialogWidth: '500px',
            dialog: false,
            dialogDelete: false,
            loading: false,
            loadingClients: false,
            clients: [],
            users: [],
            edit: false,
            editedItem: {VALOR:null},
            imageTime: new Date().getTime(),
            baseUrl: process.env.VUE_APP_API_URL,
            defaultImage: require('../../../../src/assets/user.png'),
            tableHeaders: [
                { text: translate('Usuário', 'Usuarios'), value: 'imagem', width: '10%', sortable: false },
                { text: translate('Cliente', 'Usuarios'), value: 'CLIENTE', filterable: true, width: '10%', align:'start' },
                { text: translate('Descrição', 'Usuarios'), value: 'NOME', filterable: true, width: '20%' },
                { text: translate('Tipo', 'Usuarios'), value: 'TIPO', filterable: true, width: '10%', align:'start' },
                { text: translate('Email', 'Usuarios'), value: 'EMAIL', filterable: true, width: '20%', align:'start' },
                { text: translate('Último Acesso', 'Usuarios'), value: 'ULTIMO_ACESSO', filterable: true, width: '15%', align:'center' },
                { text: translate('Ações', 'Usuarios'), value: 'actions', sortable: false, width: '10%', align:'center' },
                { text: translate('Adm', 'Usuarios'), value: 'ADM', sortable: false, width: '10%', align:'start' },
                { text: translate('Ativo', 'Usuarios'), value: 'ATIVO', sortable: false, width: '10%', align:'start' },
                { text: translate('Excluir Usuário', 'Usuarios'), value: 'excluirUsuario', sortable: false, width: '10%', align:'center' }
            ],
            labels: {
                textLoading: translate('Carregando Usuarios', 'Usuarios'),
                buscar: translate('Buscar', 'Usuarios'),
                nome: translate('Nome', 'Usuarios'),
                email: translate('Email', 'Usuarios'),
                funcao: translate('Função', 'Usuarios'),
                cliente: translate('Cliente', 'Usuarios'),
                operador: translate('Operador', 'Usuarios'),
                hidesUnlinkedCall: translate('Ocultar atendimentos dos quais o usuário não esteja vinculado', 'Usuarios')
            },
            rules: {
                required: (val) => !!val || translate('Deve ser preenchido!','Usuarios'),
                email: (val) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(val) || translate('Email Invalido!', 'Usuarios');
                },
                operatorFunction: (val) => !!val || translate('Uma função precisa ser informada!', 'Usuarios'),
                customer: (val) => !!val || translate('Um cliente precisa ser informado!', 'Usuarios'),
            },
            menuProp:{
                overflowY:false,
                offsetY:false 
            },
            userRoles: [],
            userType: null,
            autocompleteFunctionErrorMessages: [],
            autocompleteCustomerErrorMessages: []
        }
    },
    methods: {
        async loadCustomers(val){
            this.loadingClients = true
            await getClientsByCompanyIdAndName({companyId:this.user.EMPRESA_ID, name:val})
                .then(function(response){
                    this.clients = response.data
                }.bind(this))
                .finally(function(){
                    this.loadingClients = false
                }.bind(this))
        },
        async loadUsers() {
            await loadAllByCompanyId(this.user.EMPRESA_ID)
                .then(function(response){
                    this.users = response.data
                    this.loading = false
                }.bind(this))
                .catch(function(){ this.loading = false }.bind(this))
        },
        async loadRoles() {
            await loadAllUserRoles()
                .then(function(response){
                    this.userRoles = response.data
                }.bind(this))
        },
        changeRouter(route) {
            this.$router.push(route)
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        },
        deleteItem(item) {
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        deleteCalcel () {
            this.editedItem = {VALOR:null}
            this.dialogDelete = false
        },
        clearEdititem(){
            this.editedItem = {VALOR:null}
        },
        addPerson(isClient){
            this.clients.push({NOME: this.searchClient})
            this.editedItem.addClient = isClient
        },
        async deleteConfirm () {
            this.dialogDelete = false
            this.loading = true
            await deleteProduct(this.editedItem.ID).then(function(){
                this.loading = false
                this.loadUsers()
            }.bind(this))
            this.close()
        },
        validateForm() {
            if(!this.editedItem.NOME || !this.editedItem.NOME.length)  return true
            if(!this.editedItem.EMAIL || !this.editedItem.EMAIL.length)  return true
            if(!this.client && this.editedItem.userType == 'C')  return true
            return false
        },
        close () {
            this.editedItem = {}
            this.dialog = false
            this.edit = false
        },
        editItem (item) {
            this.loadCustomers()
            this.edit = true
            this.editedItem = Object.assign({}, item)
            this.editedItem.userType = this.editedItem.CLIENTE_ID ? 'C' : 'P'
            this.userType = this.editedItem.userType
            this.client = {NOME: this.editedItem.CLIENTE, ID: this.editedItem.CLIENTE_ID}
            this.clients = [this.client]
            let self = this
            setTimeout(function(){
                self.dialog = true
            },10)
        },
        async save(item){
            this.reValidateRules()

            var self = this
            self.editedItem = Object.assign(this.editedItem, item)

            const isFromModal = !item
            const isOperator = this.editedItem.userType === 'P'
            if(isOperator && isFromModal) self.editedItem.CLIENTE_ID = null

            const isCustomer = this.editedItem.userType === 'C'
            if(isCustomer) self.editedItem.FUNCAO_USUARIO_ID = null

            const isInvalid = areFieldsInvalid()
            if(isInvalid) return

            this.loading = true
            this.editedItem.EMPRESA_ID = this.user.EMPRESA_ID

            if (self.editedItem.USUARIO_ID){

                await updateUserCompany(self.editedItem)
                this.loadUsers()
                this.refresh()
            
            } else {

                await addUserCompany(self.editedItem)
                this.loadUsers()
                this.refresh()
            
            }
            this.cleanRules()
            this.close()

            //#region Internal functions
            function areFieldsInvalid(){
                const validations = [
                    {
                        isInvalid: isOperator && !self.editedItem.FUNCAO_USUARIO_ID,
                        name: `Is operator and doesn't have a function`
                    },
                    {
                        isInvalid: isCustomer && !self.editedItem.CLIENTE_ID,
                        name: `Is customer and doesn't have a customer linked`
                    },
                ]

                return validations.some(v => v.isInvalid)
            }
            //#endregion
        },
        reValidateRules(){
            if(this.$refs.autocompleteFunction && !this.$refs.autocompleteFunction.validate()) this.autocompleteFunctionErrorMessages = [this.rules.operatorFunction]
            if(this.$refs.autocompleteCustomer && !this.$refs.autocompleteCustomer.validate()) this.autocompleteCustomerErrorMessages = [this.rules.customer]
        },
        cleanRules(){
            this.autocompleteFunctionErrorMessages = []
            this.autocompleteCustomerErrorMessages = []
        },
        deleteUserModal(item){
            this.deleteUserDialog = true
            this.userToDelete = item
        }
        ,
        async deleteUser(){
            this.deleteUserDialog = false
            await deleteUser(this.userToDelete)
            this.loadUsers()
            this.refresh()
            this.userToDelete = null
        }
        ,
        refresh() {
            this.loading = false
            this.editedItem = {}
            this.client = null
            this.clients = []
        },
        getAvatarimage(img) {
            return img ? this.baseUrl + img + '?t=' + this.imageTime : this.defaultImage
        }
    },
    computed:{
        ...user.mapGetters(['user'])
    },
    async mounted() {
        this.onResize()
        this.loading = true
        await this.loadRoles()
        await this.loadUsers()
    },
    watch: {
        userType(value){
            if(value) this.editedItem.userType = value
        }
    },

}
</script>
<style scoped>
.headerPage{
    height: 2rem;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.el-tabs__item.is-active{
    color:black !important;
}
.el-tabs__active-bar{
    background-color: #000000 !important;
}
.table{
    width: 90%;
}
.scrollStyle{
    overflow-y: none !important;
    overflow-x: none !important;
}
.actionButtons{
    display: contents;
}
.rowPadding{
    padding: 0 1em;
    justify-content: center;
}
.v-tooltip__content {
    text-align: left !important;
}
@media only screen and (max-width: 600px) {
    table{
        width: 100%;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .table{
        width: 100%;
    }
}
</style>
